import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Crown, Zap, MessageCircle } from "lucide-react";
import { onUpgradeModal, PLANO_LABELS } from "../lib/planos";

export default function UpgradeModal() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [payload, setPayload] = useState(null);

  useEffect(() => {
    const off = onUpgradeModal((p) => {
      setPayload(p || {});
      setOpen(true);
    });
    return off;
  }, []);

  if (!payload) return null;

  const planoMin = payload.plano_minimo || "pro";
  const planoMinNome = payload.plano_minimo_nome || PLANO_LABELS[planoMin] || "Pro";
  const planoAtualNome = payload.plano_atual_nome || PLANO_LABELS[payload.plano_atual] || "Start";
  const feature = payload.feature_required || "este recurso";

  const featureLabels = {
    secretario: "Criar Secretário",
    pos_venda: "Pós-Venda Automatizado",
    contas_pagar: "Contas a Pagar PF/PJ",
    infinitepay: "Pagamentos via InfinitePay",
    max_carros: "Mais carros/rotas",
  };
  const featureNome = featureLabels[feature] || feature;

  const irParaPlanos = () => {
    setOpen(false);
    navigate("/planos");
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md" data-testid="upgrade-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-amber-700">
            <Crown className="h-5 w-5" />
            Upgrade necessário
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="rounded-xl bg-gradient-to-br from-amber-50 to-orange-50 border border-amber-200 p-4">
            <p className="text-xs uppercase font-bold text-amber-700 tracking-wider">
              Recurso bloqueado
            </p>
            <p className="text-lg font-bold text-gray-900 mt-1">{featureNome}</p>
            <p className="text-sm text-gray-700 mt-2">
              {payload.message ||
                `Esta funcionalidade está disponível a partir do plano ${planoMinNome}.`}
            </p>
            {payload.limite_atual != null && (
              <p className="text-xs text-amber-800 mt-2 bg-amber-100 rounded px-2 py-1 inline-block">
                Uso atual: {payload.uso_atual} de {payload.limite_atual} permitido
              </p>
            )}
          </div>

          <div className="flex items-center justify-between text-sm bg-gray-50 rounded-lg p-3">
            <div>
              <p className="text-gray-500 text-xs">Seu plano hoje</p>
              <p className="font-bold">{planoAtualNome}</p>
            </div>
            <Zap className="h-5 w-5 text-amber-500" />
            <div className="text-right">
              <p className="text-gray-500 text-xs">Plano sugerido</p>
              <p className="font-bold text-emerald-700">{planoMinNome}</p>
            </div>
          </div>
        </div>
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button
            variant="outline"
            onClick={() => setOpen(false)}
            data-testid="upgrade-modal-cancel"
          >
            Agora não
          </Button>
          <Button
            onClick={irParaPlanos}
            className="bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white gap-2"
            data-testid="upgrade-modal-ver-planos"
          >
            <Crown className="h-4 w-4" /> Ver planos
          </Button>
          <a
            href={`https://wa.me/5567991992593?text=${encodeURIComponent(
              `Olá! Quero fazer upgrade para o plano ${planoMinNome}.`
            )}`}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center gap-2 px-4 h-10 rounded-md text-sm font-medium bg-emerald-600 text-white hover:bg-emerald-700"
            data-testid="upgrade-modal-whatsapp"
          >
            <MessageCircle className="h-4 w-4" /> Falar no WhatsApp
          </a>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
